<!-- ==========================================
     Users Management Page
     ========================================== -->
<div class="users flex flex-col h-full">

  <!-- Page Header -->
  <div class="page-header">
    <h1>Users</h1>
  </div>

  <!-- Table Content -->
  <div class="flex-1 p-8 flex flex-col min-h-0">

    <!-- Actions Bar -->
    <div class="mb-6 flex flex-wrap items-center gap-4 users-actions-bar">
      <button
        class="btn-accent"
        type="button"
        (click)="openNewUserModal(userTemplate)"
      >
        <ng-icon name="featherPlus" size="16"></ng-icon>
        Add User
      </button>
    </div>

    <!-- Table -->
    <div class="users-table-wrapper" *ngIf="!isListLoading && users.length">
      <table class="w-full caption-bottom text-sm">
        <!-- Table Header -->
        <thead class="users-thead">
          <tr>
            <th class="users-th users-th--id">ID</th>
            <th class="users-th users-th--name">Name</th>
            <th class="users-th users-th--email">Email</th>
            <th class="users-th users-th--phone">Phone</th>
            <th class="users-th users-th--role">Role</th>
            <th class="users-th users-th--actions">Actions</th>
          </tr>
        </thead>

        <!-- Table Body -->
        <tbody>
          <tr class="users-row cursor-pointer" *ngFor="let user of displayedUsers" (click)="onUserRowClick(user, userTemplate)">
            <!-- ID -->
            <td class="users-td users-td--id">{{ user.id }}</td>

            <!-- Name -->
            <td class="users-td">
              <span class="font-medium text-foreground">{{ user.name }}</span>
            </td>

            <!-- Email -->
            <td class="users-td">{{ user.email }}</td>

            <!-- Phone -->
            <td class="users-td users-td--nowrap">{{ user.phone || '—' }}</td>

            <!-- Role Badge -->
            <td class="users-td">
              <span
                class="users-role-badge"
                [class.users-role-badge--super-admin]="user.role_id === 1"
                [class.users-role-badge--admin]="user.role_id === 2"
                [class.users-role-badge--user]="user.role_id === 3"
                [class.users-role-badge--consultant]="user.role_id === 4"
              >
                {{ userRoleName(user.role_id) }}
              </span>
            </td>

            <!-- Actions -->
            <td class="users-td users-td--actions">
              <div class="flex justify-end relative">
                <button
                  class="w-[32px] h-[32px] flex items-center justify-center rounded-md hover:bg-gray-200 border border-transparent transition-colors focus:bg-gray-200 focus:outline-none"
                  (click)="toggleDropdown(user.id, $event); $event.stopPropagation(); $event.preventDefault()"
                >
                  <span class="text-muted-foreground flex items-center">
                    <ng-icon name="featherMoreVertical" size="20"></ng-icon>
                  </span>
                </button>

                <div *ngIf="activeDropdownId === user.id"
                     clickOutside (clickedOutside)="activeDropdownId = null"
                     class="absolute right-0 top-full mt-1 w-36 rounded-md shadow-lg z-[100] py-1 flex flex-col"
                     style="background-color: var(--card); border: 1px solid var(--border);">

                  <button
                    class="flex items-center gap-2 px-4 py-2 text-sm text-foreground hover:bg-gray-200 group text-left w-full transition-colors"
                    (click)="openEditUserModal(user, userTemplate); activeDropdownId = null; $event.stopPropagation(); $event.preventDefault()"
                  >
                    <span class="text-muted-foreground group-hover:text-foreground transition-colors flex items-center">
                      <ng-icon name="featherEdit2" size="16"></ng-icon>
                    </span>
                    Edit
                  </button>

                  <button
                    class="flex items-center gap-2 px-4 py-2 text-sm text-foreground hover:bg-gray-200 hover:text-red-500 group text-left w-full transition-colors"
                    (click)="openConfirmDeleteModal(confirmDeleteTemplate, user.id); activeDropdownId = null; $event.stopPropagation(); $event.preventDefault()"
                  >
                    <span class="text-muted-foreground group-hover:text-red-500 transition-colors flex items-center">
                      <ng-icon name="featherTrash2" size="16"></ng-icon>
                    </span>
                    Delete
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div
      class="mt-6 flex items-center justify-center w-full users-pagination"
      *ngIf="users.length"
    >
      <pagination
        [totalItems]="users.length"
        [itemsPerPage]="itemsPerPage"
        [maxSize]="10"
        [ngModel]="currentPage"
        (pageChanged)="pageChanged($event)"
      ></pagination>
    </div>

    <!-- Empty State -->
    <div class="users-empty-state" *ngIf="!isListLoading && !users.length">
      <ng-icon name="featherUsers" size="48"></ng-icon>
      <p>No Users Yet</p>
      <button
        class="btn-accent"
        type="button"
        (click)="openNewUserModal(userTemplate)"
      >
        <ng-icon name="featherPlus" size="16"></ng-icon>
        Add First User
      </button>
    </div>

  </div>
</div>

<!-- ==========================================
     Modals
     ========================================== -->

<ng-template #userTemplate>
  <app-user-modal
    (closeModal)="userToEdit = null; userModalRef?.hide()"
    (userCreatedOrUpdated)="onUserUpdatedOrCreated()"
    [userToEdit]="userToEdit"
  ></app-user-modal>
</ng-template>

<ng-template #confirmDeleteTemplate>
  <app-confirm-modal
    (closeModal)="userToEdit = null; confirmDeleteModalRef?.hide()"
    (confirm)="onDeleteUser(userId)"
    [modalTitle]="'Confirm delete, please'"
    [confirmationText]="'Do you want to delete this user?'"
  ></app-confirm-modal>
</ng-template>
